var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeftRight = function SvgArrowLeftRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m3.247 12.998 1.48 1.295a.99.99 0 0 1 0 1.414c-.396.39-1.037.39-1.432 0L.445 13.06A1.48 1.48 0 0 1 0 12c0-.402.158-.779.444-1.06l2.85-2.648a1.02 1.02 0 0 1 1.433 0 .99.99 0 0 1 0 1.414L3.25 10.998h11.75a1 1 0 0 1 0 2zm9.506-8-1.48 1.296a.99.99 0 0 0 0 1.414 1.02 1.02 0 0 0 1.432 0l2.85-2.647C15.843 4.777 16 4.4 16 4s-.158-.778-.444-1.06L12.706.293a1.02 1.02 0 0 0-1.433 0 .99.99 0 0 0 0 1.414L12.75 3H1.001a1 1 0 0 0 0 2z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowLeftRight;